import React, { useEffect, useMemo, useState } from "react";

import { buildImageCandidates } from "../utils/imageUrl";

export default function ImageWithFallback({
  src,
  fallbackSrcs = [],
  placeholderSrc = "/logos/default-item.jpg",
  alt = "",
  onError,
  ...props
}) {
  const candidates = useMemo(
    () => buildImageCandidates([src, ...fallbackSrcs], placeholderSrc),
    [src, fallbackSrcs, placeholderSrc]
  );
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [candidates]);

  const activeSrc = candidates[Math.min(index, Math.max(0, candidates.length - 1))] || placeholderSrc;

  const handleError = (event) => {
    if (index < candidates.length - 1) {
      setIndex((current) => Math.min(current + 1, candidates.length - 1));
      return;
    }
    if (typeof onError === "function") onError(event);
  };

  return <img {...props} alt={alt} src={activeSrc} onError={handleError} />;
}
